export default __webpack_public_path__ + "static/media/looperinsights.81ae09a6.png";